import React, { useState } from "react"
import { styled, alpha } from "@mui/material/styles"
import SearchIcon from "@mui/icons-material/Search"
import InputBase from "@mui/material/InputBase"
import Popper from "@mui/material/Popper"
import Paper from "@mui/material/Paper"
import MenuItem from "@mui/material/MenuItem"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import Box from "@mui/material/Box"

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}))

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}))

const SearchBar = ({ onSearch, blogs }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleSearchChange = (event) => {
    const value = event.target.value
    setSearchTerm(value)
    setAnchorEl(event.currentTarget)
    onSearch(value)

    if (value.length > 0) {
      const filteredResults = blogs
        .filter((blog) => blog.title.toLowerCase().includes(value.toLowerCase()))
        .map((blog) => blog.title)
      setSearchResults(filteredResults)
    } else {
      setSearchResults([])
    }
  }

  const handleSearchResultClick = (result) => {
    setSearchTerm(result)
    onSearch(result)
    setSearchResults([])
    setAnchorEl(null)
  }

  const handleClickAway = () => {
    setSearchResults([])
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl) && searchResults.length > 0
  const id = open ? "search-popper" : undefined

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box sx={{ position: "relative", width: { xs: "100%", sm: "auto" }, display: "flex", alignItems: "center" }}>
        <Search sx={{ flexGrow: 1 }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ "aria-label": "search" }}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Search>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          <Paper elevation={3} sx={{ p: 1, maxHeight: 300, overflowY: "auto", width: "100%" }}>
            {searchResults.map((result, index) => (
              <MenuItem key={index} onClick={() => handleSearchResultClick(result)}>
                {result}
              </MenuItem>
            ))}
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  )
}

export default SearchBar;

